import { Link } from "@tanstack/react-router"
import { LockIcon } from "lucide-react"
import { useStore } from "zustand"

import { Button } from "@/components/ui/button"
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { store } from "@/lib/store"

export function HomeReferralsCard() {
  const hasPermissions = useStore(store, (state) => state.hasPermissions)

  const hasReferralsViewPermission = hasPermissions([
    "customer.view_company",
    "partners.view_partner",
  ])

  return (
    <Card>
      <CardHeader>
        <CardTitle>Lender Referrals</CardTitle>
      </CardHeader>
      <CardContent>
        Send referrals to Boundless to monetize declines or bad fits. From the
        platform, you can track your referral pipeline and monitor your
        referrals&apos; progress through each funding stage.
      </CardContent>
      <CardFooter>
        {hasReferralsViewPermission ? (
          <Button asChild>
            <Link to="/partners/referrals">View Referrals</Link>
          </Button>
        ) : (
          <Button disabled>
            View Referrals
            <LockIcon className="ml-2 h-4 w-4" />
          </Button>
        )}
      </CardFooter>
    </Card>
  )
}
